import { render, staticRenderFns } from "./Postcodechecker.vue?vue&type=template&id=5c73b313&scoped=true"
import script from "./Postcodechecker.vue?vue&type=script&lang=js"
export * from "./Postcodechecker.vue?vue&type=script&lang=js"
import style0 from "./Postcodechecker.vue?vue&type=style&index=0&id=5c73b313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c73b313",
  null
  
)

export default component.exports